import { defineMessages } from "react-intl";
const messages = defineMessages({
    formSubmit: {
        id: "app.admin.addFeature.formSubmit.button.text",
        defaultMessage: "Give Access",
    },
    formTitle: {
        id: "app.admin.addFeature.formTitle.text",
        defaultMessage: "Beta Feature Access",
    },
    featureOrganization: {
        id: "app.admin.addFeature.organization.text",
        defaultMessage: "Organization",
    },
    featureOrganizationRequired: {
        id: "app.admin.addFeature.organizationRequired.text",
        defaultMessage: "Organization is required",
    },
    featureSuccessCreation: {
        id: "app.admin.createFeature.success.text",
        defaultMessage: "Feature access created successfully",
    },
    featureAction: {
        id: "app.admin.addFeature.action.text",
        defaultMessage: "Features",
    },
    featureActionRequired: {
        id: "app.admin.addFeature.actionRequired.text",
        defaultMessage: "Features are required",
    },
    featureUser: {
        id: "app.admin.addFeature.user.text",
        defaultMessage: "Users",
    },
});
export default messages;
